/**
 * 应用根组件：把 3D 画布与普通 HTML 界面叠放在同一个 Recoil 状态树中。
 * 两层通过 screens、sound-config、active-letter 等 atom 相互通信。
 */
import { RecoilRoot } from 'recoil';
import Dom from './components/dom/Dom';
import WebGLWithGPUCheck from './components/webgl/WebGLWithGPUCheck';

function App() {
    return (
        // RecoilRoot 相当于全局状态容器，所有 atom hook 必须在它的内部使用。
        <RecoilRoot>
            {/* 先检测 GPU，再创建 Three.js Canvas。 */}
            <WebGLWithGPUCheck />
            {/* 加载页、文案、菜单、贺卡和声音等普通 HTML 界面。 */}
            <Dom />
        </RecoilRoot>
    );
}

export default App;
